import React from "react";
import "./Maintenance";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import {
  AppBar,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Toolbar,
	Tooltip,
  Typography
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import camelcaseKeys from "camelcase-keys";
import DenseTable from "../../Dashboard/RenderTable";
import {
	GetSectionPermission,
	getSynchStatus,
	PaperComponent
} from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import { IoMdCloseCircleOutline } from "react-icons/io";
const CData = [
	{ key: "WorkOrderId", name: "Work Order Id" },
	{ key: "AssetId", name: "Asset Id" },
	{ key: "Datacenter", name: "Data Center Name" },
	{ key: "JobType", name: "Job Type" },
	{ key: "ReceivedDate", name: "Received Date", format: "DateTime" },
	{ key: "DueDate", name: "Due Date", format: "DateTime" },
	{ key: "ClosedDate", name: "Closed Date", format: "DateTime" },
	{ key: "Requestor", name: "Requestor" },
	{ key: "Type", name: "Type" },
	{ key: "Status", name: "Status" },
	{ key: "ServiceLocation", name: "Service Location" },
	{ key: "Technician", name: "Technician" },
  { key: "WorkHours", name: "Work Hours" },
  {
				key: "PrivateNote",
				name: "Private Note",
				clickable: true				
			},
			{
				key: "PublicNote",
				name: "Public Note",
				clickable: true
			},
	{ key: "ServiceDescription", name: "Description", width: 450 },
	{ key: "Source", name: "Source" }
];
class NotificationsSentWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			NotificationsSentList: [],
			conditions: [],
			rawData: [],
			IsConditionOpen: false,
			FiltersView: false,
			SelectedAttribute: undefined,
			syncStatus: undefined
		};
	}

	componentDidMount() {
		this.GetNotificationsSentDataByMonth(
			this.props.propertyId,
			this.props.endDate,
			this.props.startDate
		);
	}
	componentWillReceiveProps(newProps) {
		if (
			newProps.propertyId != this.props.propertyId ||
			newProps.endDate != this.props.endDate ||
			newProps.startDate != this.props.startDate
		) {
			this.GetNotificationsSentDataByMonth(
				newProps.propertyId,
				newProps.endDate,
				newProps.startDate
			);
		}
	}

	/** notification sent data by month */
	GetNotificationsSentDataByMonth = (propertyId, endDate, startDate) => {
		const params = {
			propertyId: propertyId,
			endDate: endDate,
			startDate: startDate
		};
		apiRequest({
			url: API_URL.maintenance.CustomerNotificationSent,
			params
		}).then(MaintenanceList => {
			this.setState({
				NotificationsSentList: MaintenanceList.data,
				conditions: camelcaseKeys(MaintenanceList.condition),
				rawData: MaintenanceList.rawData,
				syncStatus: ((MaintenanceList.syncStatus || [])[0] || {}).SyncStatus
			});
		});
	};

	/** details */
	getDetailByAttributeAndType = (attributeName) => {
		const SortedRawData = this.state.rawData;
		const result = SortedRawData.filter(
			value => value.AttributeName == attributeName
		);

		// console.log(result);
		this.setState({
			SortedRawData: result,
			IsConditionOpen: true,
			SelectedAttribute: attributeName
		});
	};

	render() {
		const {
			NotificationsSentList,
			IsConditionOpen,
			conditions,
			FiltersView,
			SortedRawData,
			SelectedAttribute,
			syncStatus
		} = this.state;

		const permission = GetSectionPermission(
			SECTIONS.MAINTENANCE,
			SECTIONS.INCIDENT_OPEN_ISSUES
		);
		const ShowData = permission.showData;
		return (
			<>
				<div className={"maintenance-widget-wrapper w-100"}>
					<div className={"maintenance-title-div"}>
						{"Incidents / Open Issues"}{" "}
						{ShowData && (
							<Tooltip title={"View Filters"}>
								<IconButton
									onClick={() =>
										this.setState({ IsConditionOpen: true, FiltersView: true })}
									size={"small"}
								>
									<InfoOutlined fontSize={"small"} />
								</IconButton>
							</Tooltip>
						)}
					</div>
					<div>
						<table id={"maintenance-widget-table"}>
							<thead>
								<tr>
									<th />
									<th>&nbsp;</th>
								</tr>
							</thead>
							<tbody>
								{(NotificationsSentList || []).map((item, index) => (
									<tr key={"NotificationsSentList" + index}>
										<td className={"w-75"} style={{ paddingLeft: "0px" }}>
											{item["attributeName"]}{" "}
										</td>

										<td
											onClick={() =>
												ShowData &&
												this.getDetailByAttributeAndType(
													item["attributeName"],
													null
												)}
											className={
												"bordered-td w-25 " +
												(ShowData &&
													item["attributeValue"] != 0 &&
													"pointer underline")
											}
										>
											{item["attributeValue"] != 0
												? item["attributeValue"]
												: "-"}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				{IsConditionOpen && (
					<Dialog
						open={IsConditionOpen}
						maxWidth={"md"}
						onClose={() =>
							this.setState({ IsConditionOpen: false, FiltersView: false })}
						aria-labelledby={"responsive-dialog-title"}
						PaperComponent={PaperComponent}
						fullScreen={!FiltersView}
					>
						<AppBar
							style={{ position: "relative", backgroundColor: "#064473" }}
						>
							<Toolbar>
								<Typography
									variant={"h6"}
									style={{ flex: "1" }}
								>
									{FiltersView ? (
										<DialogTitle
											style={{ cursor: "move" }}
											id={"responsive-dialog-title"}
											className={"common-color white-label"}
										>
											{"Incidents / Open Issues"}
											<span className={"condition-label white-label"}>
												{"(Applied filters)\r"}
											</span>
										</DialogTitle>
									) : (
										<DialogTitle
											style={{ cursor: "move" }}
											id={"responsive-dialog-title"}
										>
											{SelectedAttribute}
										</DialogTitle>
									)}
								</Typography>
								<Tooltip title={"end"}>
									<IconButton
										edge={"end"}
										color={"inherit"}
										onClick={() => {
											this.setState({
												IsConditionOpen: false,
												FiltersView: false
											});
										}}
										aria-label={"close"}
										className={"white-button"}
									>
										<IoMdCloseCircleOutline />
									</IconButton>
								</Tooltip>
							</Toolbar>
						</AppBar>
						<DialogContent>
							<DialogContentText>
								{FiltersView ? (
									conditions &&
									conditions.map(item => (
										<div className={"col-xs-12"}>
											<div className={"col-xs-12 start-xs condition-heading"}>
												<b>{item.attributeName}</b>{" "}
											</div>
											<div>
												{item.filterCondition.split("|").map(condition => (
													<div className={"col-xs-11 condition-label"}>
														{condition}{" "}
													</div>
												))}{" "}
											</div>
										</div>
									))
								) : (
									<div>
										<DenseTable
											columns={CData}
											data={SortedRawData}
											config={{
												minRows: 10
											}}
										/>
									</div>
								)}
								{syncStatus && (
									<span className={"data-sync-text"}>
										{getSynchStatus(syncStatus)}
									</span>
								)}
							</DialogContentText>
						</DialogContent>
					</Dialog>
				)}
			</>
		);
	}
}
export default NotificationsSentWidget;
